import styled from "@emotion/styled";
import clsx from "clsx";

import { isTestEnv } from "@smart/itops-utils-basic";

export const sidebarWidth = 300;
export const sidebarSpeed = "0.4s";
export const rootContainerId = "intake-form-root-container";

export const ScrollWrapper = ({
  children,
  newUI,
  isPreview,
}: {
  children: React.ReactNode;
  newUI?: boolean;
  isPreview?: boolean;
}) => (
  <div
    id={rootContainerId}
    className={clsx(
      "w-full h-full overflow-hidden top-0 left-0 @container",
      isPreview && "rounded",
      newUI ? "relative" : "absolute",
    )}
  >
    {children}
  </div>
);

export const OldPageWrapper = styled.div<{ sidebar: boolean }>`
  width: 100%;
  height: 100%;
  transition: padding-left ${sidebarSpeed} ease;
  overflow: hidden auto;

  scroll-behavior: smooth;
  scroll-padding-top: 15rem;

  ${(props) =>
    isTestEnv()
      ? ""
      : `
  @container (min-width: ${props.theme.breakPoints.readable + sidebarWidth}px) {
    padding-left: ${props.sidebar ? sidebarWidth * props.theme.baseUnit : 0}px;
  }
  `}
`;

export const PageWrapper = ({
  children,
  sidebar,
}: {
  children: React.ReactNode;
  sidebar: boolean;
}) => (
  <div
    className={clsx(
      "w-full h-full overflow-x-hidden overflow-y-auto transition-[padding-left] duration-[0.4s] ease-in-out scroll-smooth scroll-pt-[15rem]",
      sidebar ? "@tablet:pl-[30rem]" : "@tablet:pl-0",
    )}
  >
    {children}
  </div>
);

export const OldPage = styled.main`
  --background: ${(props) => props.theme.scheme.grey.r0};
  background: var(--background);
  border-radius: 4px;
  margin: ${(props) => props.theme.baseUnit * 3}rem auto
    ${(props) => props.theme.baseUnit * 10}rem;
  max-width: 90%;
  width: ${(props) => props.theme.breakPoints.readable}px;
`;

export const Page = ({
  children,
  className,
  isPreview,
}: {
  children: React.ReactNode;
  className?: string;
  isPreview?: boolean;
}) => (
  <div className="bg-neutral-50 min-h-full print:bg-white">
    <main
      className={clsx(
        "rounded-small mx-auto pb-[10rem] max-w-[90%] w-[80rem]",
        isPreview && "w-full max-w-full pt-[0rem] pb-[5rem]",
        !isPreview && "pt-[3rem]",
        className,
      )}
    >
      {children}
    </main>
  </div>
);

export const OldSection = styled.section`
  padding: 1rem 2rem;

  a {
    color: ${(props) => props.theme.palette.primary.base};
    text-decoration: underline;
  }
`;

export const Section = ({
  children,
  className,
  dataTestId,
}: {
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
}) => (
  <section
    className={clsx(
      "px-[3.2rem] pt-[3.2rem] pb-[5.6rem] rounded bg-white",
      className,
    )}
    data-testid={dataTestId || "section"}
  >
    {children}
  </section>
);
